import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastComponent, ToastService } from '@pearsonvue/topaz-angular-ui';

export interface ToastData {
  name: string;
}

@Component({
  selector: 'app-toast-example',
  standalone: false,
  templateUrl: './toast-example.component.html',
  styleUrl: './toast-example.component.scss'
})

export class ToastExampleComponent implements OnInit {
  @ViewChild(ToastComponent, { static: true }) public toast!: ToastComponent;
  public data!: ToastData;
  constructor(private toastService: ToastService<ToastData>) { }
  ngOnInit(): void {
    this.data = this.toastService.getToastData(this.toast);
  }
}
